import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RequestService } from '../request.service';
import {
  SeguridadActualizarRolInputDTO,
  SeguridadActualizarRolResponseDTO,
  SeguridadAsignacionesResponseDTO,
  SeguridadAsignacionesUsuarioDTO,
  SeguridadCatalogoPermisosResponseDTO,
  SeguridadCrearRolInputDTO,
  SeguridadCrearRolResponseDTO,
  SeguridadAuditoriaFiltrosDTO,
  SeguridadAuditoriaListDTO,
  SeguridadAuditoriaResponseDTO,
  SeguridadEliminarRolResponseDTO,
  SeguridadRolEliminadoDTO,
  SeguridadMisPermisosDTO,
  SeguridadMisPermisosResponseDTO,
  SeguridadPermisoCatalogoDTO,
  SeguridadRolActualizadoDTO,
  SeguridadRolCreadoDTO,
  SeguridadRolDisponibleDTO,
  SeguridadRolesResponseDTO,
  SeguridadScopeAsignacionInputDTO,
  SeguridadScopesDisponiblesDTO,
  SeguridadScopesDisponiblesResponseDTO,
  SeguridadSyncOverridesResponseDTO,
  SeguridadSyncOverridesResultDTO,
  SeguridadSyncPermisosRolResponseDTO,
  SeguridadSyncPermisosRolResultDTO,
  SeguridadSyncRolesResponseDTO,
  SeguridadSyncRolesResultDTO,
  SeguridadSyncScopesResponseDTO,
  SeguridadSyncScopesResultDTO,
  SeguridadUsuarioAsignacionesDTO,
  SeguridadUsuariosResponseDTO,
} from './DTO/seguridad-response.dto';

@Injectable({
  providedIn: 'root',
})
export class SeguridadWorkspaceService {
  constructor(private http: HttpClient, private requestSvc: RequestService) {}

  private buildHeaders(): HttpHeaders {
    return new HttpHeaders({ token: this.requestSvc.master.apiKey });
  }

  async getUsuariosConAsignaciones(): Promise<SeguridadUsuarioAsignacionesDTO[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadUsuariosResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/usuarios`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener usuarios de seguridad';
              return reject(new Error(msg));
            }
            resolve(
              (response.respuesta || []) as SeguridadUsuarioAsignacionesDTO[]
            );
          },
          (error) => reject(error)
        );
    });
  }

  async getRolesDisponibles(): Promise<SeguridadRolDisponibleDTO[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadRolesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/roles`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener roles disponibles';
              return reject(new Error(msg));
            }
            resolve(
              (response.respuesta || []) as SeguridadRolDisponibleDTO[]
            );
          },
          (error) => reject(error)
        );
    });
  }

  async getMisPermisos(): Promise<SeguridadMisPermisosDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadMisPermisosResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/mis-permisos`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener mis permisos';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadMisPermisosDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async getCatalogoPermisos(): Promise<SeguridadPermisoCatalogoDTO[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadCatalogoPermisosResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/permisos`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener catalogo de permisos';
              return reject(new Error(msg));
            }
            resolve(
              (response.respuesta || []) as SeguridadPermisoCatalogoDTO[]
            );
          },
          (error) => reject(error)
        );
    });
  }

  async getScopesDisponibles(): Promise<SeguridadScopesDisponiblesDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadScopesDisponiblesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/scopes-disponibles`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener scopes disponibles';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadScopesDisponiblesDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async syncScopesUsuario(
    idUsuario: number,
    scopes: SeguridadScopeAsignacionInputDTO[]
  ): Promise<SeguridadSyncScopesResultDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .put<SeguridadSyncScopesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/usuarios/${idUsuario}/scopes`,
          { scopes },
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al guardar los scopes';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadSyncScopesResultDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async syncOverridesUsuario(
    idUsuario: number,
    codigos: string[]
  ): Promise<SeguridadSyncOverridesResultDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .put<SeguridadSyncOverridesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/usuarios/${idUsuario}/overrides`,
          { codigos },
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al guardar los permisos individuales';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadSyncOverridesResultDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async syncRolesUsuario(
    idUsuario: number,
    idRoles: number[]
  ): Promise<SeguridadSyncRolesResultDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .put<SeguridadSyncRolesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/usuarios/${idUsuario}/roles`,
          { idRoles },
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al guardar los roles asignados';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadSyncRolesResultDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async crearRol(
    input: SeguridadCrearRolInputDTO
  ): Promise<SeguridadRolCreadoDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .post<SeguridadCrearRolResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/roles`,
          input,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al crear el rol';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadRolCreadoDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async getAuditoria(
    filtros: SeguridadAuditoriaFiltrosDTO = {}
  ): Promise<SeguridadAuditoriaListDTO> {
    let params = new HttpParams();
    if (filtros.page) params = params.set('page', String(filtros.page));
    if (filtros.limit) params = params.set('limit', String(filtros.limit));
    if (filtros.idUsuarioActor) {
      params = params.set('idUsuarioActor', String(filtros.idUsuarioActor));
    }
    if (filtros.accion) params = params.set('accion', filtros.accion);
    if (filtros.resultado) params = params.set('resultado', filtros.resultado);
    if (filtros.recurso) params = params.set('recurso', filtros.recurso);
    if (filtros.fechaDesde) params = params.set('fechaDesde', filtros.fechaDesde);
    if (filtros.fechaHasta) params = params.set('fechaHasta', filtros.fechaHasta);

    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadAuditoriaResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/auditoria`,
          { headers: this.buildHeaders(), params }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al listar auditoria';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadAuditoriaListDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async eliminarRol(idRol: number): Promise<SeguridadRolEliminadoDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .delete<SeguridadEliminarRolResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/roles/${idRol}`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al eliminar el rol';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadRolEliminadoDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async actualizarRol(
    idRol: number,
    input: SeguridadActualizarRolInputDTO
  ): Promise<SeguridadRolActualizadoDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .put<SeguridadActualizarRolResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/roles/${idRol}`,
          input,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al actualizar el rol';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadRolActualizadoDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async syncPermisosRol(
    idRol: number,
    codigos: string[]
  ): Promise<SeguridadSyncPermisosRolResultDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .put<SeguridadSyncPermisosRolResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/roles/${idRol}/permisos`,
          { codigos },
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al sincronizar los permisos del rol';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadSyncPermisosRolResultDTO);
          },
          (error) => reject(error)
        );
    });
  }

  async getAsignacionesUsuario(
    idUsuario: number
  ): Promise<SeguridadAsignacionesUsuarioDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .get<SeguridadAsignacionesResponseDTO>(
          `${environment.apiUrlV2}/workspace/seguridad/usuarios/${idUsuario}/asignaciones`,
          { headers: this.buildHeaders() }
        )
        .subscribe(
          (response) => {
            if (response.error) {
              const msg =
                typeof response.respuesta === 'string'
                  ? response.respuesta
                  : 'Error al obtener asignaciones del usuario';
              return reject(new Error(msg));
            }
            resolve(response.respuesta as SeguridadAsignacionesUsuarioDTO);
          },
          (error) => reject(error)
        );
    });
  }
}
